import { useState } from 'react';
import { clsx } from '@wonderful/wwc/dist/src/helpers/clsx';
import Link from 'next/link';
import { domPurifyWithConfigs } from '@wonderful/wwc/dist/src/utils/domPurifyWithConfigs';
import { ProductSizesProps } from './ProductSizes.types';
import { BuilderEditingHelper } from '@wonderful/wwc/dist/src/common/BuilderEditingHelper/BuilderEditingHelper';
import BuilderImage from '@/components/common/BuilderImage/BuilderImage';
import Button from '@/components/common/Button/Button';
import Section from '@/components/design/Section/Section';
import styles from './ProductSizes.module.scss';

export default function ProductSizes(props: ProductSizesProps) {
  const { title, subtitle, image, sizeLabel, sizes, availability, button } =
    props;
  const isVisible = !title;
  const [isInViewport, setIsInViewport] = useState(false);

  const onEnterViewport = () => {
    setIsInViewport(true);
  };

  return (
    <Section
      className={clsx(isInViewport ? styles.isInViewport : '')}
      onEnterViewport={onEnterViewport}
      viewportThreshold={0.01}
    >
      <div className="container">
        <div className="row">
          <BuilderEditingHelper
            componentName="ProductSizes"
            visible={isVisible}
          />
          <div className="col-12">
            <div
              className={styles.contentContainer}
              data-testid="product-sizes-text"
            >
              {title && <h2>{title}</h2>}
              {subtitle && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: domPurifyWithConfigs(subtitle),
                  }}
                />
              )}
            </div>
          </div>
        </div>

        <div
          className={[
            'row',
            styles.productsContainer,
            styles.bgGradientAll,
          ].join(' ')}
        >
          <div className={[`col-12`, styles.productContainer].join(' ')}>
            {image && (
              <div className={styles.imageContainer}>
                <Link href="/where-to-buy">
                  <BuilderImage
                    imageSrc={image.src}
                    mobileWidth={'150px'}
                    tabletWidth={'200px'}
                    alt={image.altText || ''}
                    data-testid="product-sizes-image"
                  />
                </Link>
              </div>
            )}
            {sizes && (
              <p data-testid="product-sizes">
                <strong>{sizeLabel}</strong>
                <br />
                {sizes}
              </p>
            )}
            {availability && <p>{availability}</p>}
          </div>
        </div>
        {button && button?.href && (
          <div className={styles.buttonContainer}>
            <Button
              as="Link"
              href={button?.href}
              design={button?.design}
              className={styles.button}
              data-testid="product-sizes-button"
            >
              {button?.text}
            </Button>
          </div>
        )}
      </div>
    </Section>
  );
}
